import { render, staticRenderFns } from "./BrandShare.vue?vue&type=template&id=c30921a4&scoped=true"
import script from "./BrandShare.vue?vue&type=script&lang=js"
export * from "./BrandShare.vue?vue&type=script&lang=js"
import style0 from "./BrandShare.vue?vue&type=style&index=0&id=c30921a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30921a4",
  null
  
)

export default component.exports